import React from 'react';
import {Card} from "../../../../../components/card/card.jsx";
import platePatternUtils from "../../../../../utils/plate-pattern-utils.js";
const API_URL = import.meta.env.VITE_API_URL;

const ReportContent = ({data, showMoreInformation}) => {
    const formatFileSize = (bytes) => {
        if (typeof bytes !== "number") {
            return "Não disponível";
        }

        if (bytes < 1024) {
            return `${bytes} bytes`;
        }

        const sizeInKilobytes = bytes / 1024;

        if (sizeInKilobytes < 1024) {
            return `${sizeInKilobytes.toLocaleString("pt-BR", {maximumFractionDigits: 2})} KB`;
        }

        const sizeInMegabytes = sizeInKilobytes / 1024;

        return `${sizeInMegabytes.toLocaleString("pt-BR", {maximumFractionDigits: 2})} MB`;
    };

    const imageMetadata = data.image_metadata;
    const imageResolution = imageMetadata
        ? `${imageMetadata.width} × ${imageMetadata.height} px`
        : "Não disponível";

    return (
        <>
            <Card className={"p-4"}>
                <table className="w-full border-collapse">
                    <tbody className="report-content">
                    <tr>
                        <td>
                            <div className="print:border print:border-gray-200 print:rounded-lg print:items-center print:mt-5">
                                <h3 className="text-xl font-bold text-center">
                                    Placa: {platePatternUtils.formatPlate(data.plate)} | D/H: {data.capture_time} | ID: {data.proc_id}
                                </h3>

                                <h3 className="text-xl font-bold text-center">
                                    {data.pcl_description}
                                </h3>

                                <div className="w-full flex justify-center print:mb-6">
                                    {data.image_url ? (
                                        <img
                                            className="max-w-[80%]! m-0! inline-block! w-auto! max-h-none!"
                                            src={data.image_url}
                                            alt="Imagem da Passagem"
                                        />
                                    ) : (
                                        <img
                                            className="max-w-[80%]! m-0! inline-block! w-auto! max-h-none!"
                                            src={API_URL + "/public/assets/img/sentry.imgnotfound.large.748x480.png"}
                                            alt="Imagem não encontrada"
                                        />
                                    )}
                                </div>

                                {showMoreInformation && (
                                    <div className="mt-4 flex items-start justify-start gap-2 rounded-lg border border-gray-200 p-4 text-left print:break-inside-avoid">
                                        <img
                                            className="m-0! h-[115px]! w-[154px]! max-h-none! max-w-none! shrink-0 rounded object-cover"
                                            src={imageMetadata?.original_image_url ?? data.image_url}
                                            alt="Miniatura da passagem"
                                        />
                                        <div className="min-w-0 text-sm text-gray-700">
                                            <h4 className="mb-2 font-bold">
                                                Metadados da imagem original armazenada pelo Sentry
                                            </h4>
                                            <p><strong>ID:</strong> {data.proc_id ?? "<id>"}</p>
                                            <p><strong>Tamanho:</strong> {formatFileSize(imageMetadata?.size_in_bytes)}</p>
                                            <p><strong>Resolução:</strong> {imageResolution}</p>
                                            <p className="break-all"><strong>Hash SHA-256:</strong> {imageMetadata?.sha256 ?? "Não disponível"}</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </Card>
        </>
    );
};

export default ReportContent;
